import TailwindButton from "components/general/tailwindButton";
import Image from "next/image";
import Import from "public/images/pricing/personal/import.svg";
import Briefcase from "public/images/pricing/personal/briefcase.svg";
import Zip from "public/images/pricing/personal/zip.svg";
import UserSecurity from "public/images/pricing/personal/secure-user.svg";
import ToggleButton from "src/components/general/toggleButton";
import { useState } from "react";
import {
  personalPricingOptions,
  toggleValuePremium,
  toggleValueUltimate,
} from "src/data/variables";
import { useAtom } from "jotai";
import { priceVariantAtom } from "src/atoms/pricingPage";

export interface PriceCardsProps {
  isSeasonalDiscountActive: boolean;
}

const PriceCards = ({ isSeasonalDiscountActive }: PriceCardsProps) => {
  const [priceVariant, setPriceVariant] = useAtom(priceVariantAtom);

  const [premiumToggleValue, SetPremiumToggleValues] = useState(
    personalPricingOptions.premiumYear.priceVariant,
  );
  const [ultimateToggleValue, SetUltimateToggleValues] = useState(
    personalPricingOptions.ultimateYear.priceVariant,
  );

  const [ultimatePrice, setUltimatePrice] = useState(personalPricingOptions.ultimateYear.cardPrice);
  const [ultimateDiscountPrice, setUltimateDiscountPrice] = useState(
    isSeasonalDiscountActive
      ? personalPricingOptions.ultimateYear.seasonalDiscountPrice
      : personalPricingOptions.ultimateYear.cardPrice,
  );
  const [ultimatePriceDecorator, setUltimatePriceDecorator] = useState(
    personalPricingOptions.ultimateYear.priceDecorator,
  );

  const [premiumPrice, setPremiumPrice] = useState(personalPricingOptions.premiumYear.cardPrice);
  const [premiumDiscountPrice, setPremiumDiscountPrice] = useState(
    isSeasonalDiscountActive
      ? personalPricingOptions.premiumYear.seasonalDiscountPrice
      : personalPricingOptions.premiumYear.cardPrice,
  );
  const [premiumPriceDecorator, setPremiumPriceDecorator] = useState(
    personalPricingOptions.premiumYear.priceDecorator,
  );

  const handlePremiumToggleChange = (value: string) => {
    SetPremiumToggleValues(value);
    switch (value) {
      case personalPricingOptions.premiumYear.priceVariant:
        setPremiumPrice(personalPricingOptions.premiumYear.cardPrice);
        setPremiumDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.premiumYear.seasonalDiscountPrice
            : personalPricingOptions.premiumYear.cardPrice,
        );
        setPremiumPriceDecorator(personalPricingOptions.premiumYear.priceDecorator);
        setPriceVariant(personalPricingOptions.premiumYear.priceVariant);
        break;
      case personalPricingOptions.premiumLifetime.priceVariant:
        setPremiumPrice(personalPricingOptions.premiumLifetime.cardPrice);
        setPremiumDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.premiumLifetime.seasonalDiscountPrice
            : personalPricingOptions.premiumLifetime.cardPrice,
        );
        setPremiumPriceDecorator(personalPricingOptions.premiumLifetime.priceDecorator);
        setPriceVariant(personalPricingOptions.premiumLifetime.priceVariant);
        break;
    }

    console.log(priceVariant);
  };

  const handleUltimateToggleChange = (value: string) => {
    SetUltimateToggleValues(value);
    switch (value) {
      case personalPricingOptions.ultimateMonth.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateMonth.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateMonth.seasonalDiscountPrice
            : personalPricingOptions.ultimateMonth.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateMonth.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateMonth.priceVariant);
        break;
      case personalPricingOptions.ultimateYear.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateYear.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateYear.seasonalDiscountPrice
            : personalPricingOptions.ultimateYear.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateYear.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateYear.priceVariant);
        break;
      case personalPricingOptions.ultimateLifetime.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateLifetime.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateLifetime.seasonalDiscountPrice
            : personalPricingOptions.ultimateLifetime.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateLifetime.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateLifetime.priceVariant);
        break;
    }
    console.log(priceVariant);
  };

  return (
    <div className="flex flex-col lg:flex-row w-full items-center justify-center mt-20 sm:mt-20">
      <div className="flex bg-white w-[350px] sm:w-[396px] h-[595px] rounded-lg mt-11">
        <div className="flex flex-col bg-brand-gray900 w-[342px] sm:w-[388px] mt-1 h-[587px] rounded-lg ml-[4px]">
          <div className="mt-0 sm:mt-11">
            <div className="grid grid-cols-2">
              <p className="flex justify-start ml-10 w-full font-bold text-[26px] mt-[34px]">
                Free
              </p>
              <div className="flex ml-16 sm:ml-20 h-[25px] w-[95px] rounded-xl bg-white mt-[40px]">
                <p className="flex justify-center items-center w-full text-sm ml-0.5 mt-[13px] text-black">
                  Pay nothing
                </p>
              </div>
            </div>
            <div className="flex justify-center w-full">
              <Image
                alt="Redacto the cat waving"
                width={0}
                height={0}
                src={"/images/pricing/personal/redacto-astronaut.png"}
                className="w-[222px]"
              />
            </div>

            <div className="flex justify-center w-full mt-[1.3rem]">
              <TailwindButton
                buttonBGColor="bg-brand-slate"
                buttonHeight="h-[55px] text-xl"
                buttonWidth="w-[315px]"
                buttonBorderColor="border-white"
                buttonText="Create an account"
                buttonURL="/account"
                buttonTextTailwindStyle="font-bold"
              />
            </div>
            <div className="ml-10">
              <p className="flex justify-start font-bold text-[12px] bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text">
                F E A T U R E &nbsp; H I G H L I G H T S
              </p>
              <div className="flex gap-x-2">
                <Image
                  alt="Hashtag Icon"
                  width={0}
                  height={0}
                  src={"/images/pricing/personal/hashtag.svg"}
                  className="flex items-center w-[20px]"
                />
                <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                  Delete Tweets, Likes and Retweets
                </p>
              </div>
              <div className="flex gap-x-2 -mt-2">
                <Image
                  alt="Board and pencil Icon"
                  width={0}
                  height={0}
                  src={"/images/pricing/personal/board-pencil.svg"}
                  className="flex items-center w-[20px]"
                />
                <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                  Obfuscate unlimited Reddit posts
                </p>
              </div>
              <div className="flex gap-x-2 -mt-2">
                <Image
                  alt="lock Icon"
                  width={0}
                  height={0}
                  src={"/images/pricing/personal/lock.svg"}
                  className="flex items-center w-[15px] ml-1"
                />
                <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                  Limited access to Discord and Facebook
                </p>
              </div>
              <div className="flex gap-x-2 -mt-2">
                <Image
                  alt="Browser and Phone Icon"
                  width={0}
                  height={0}
                  src={"/images/pricing/personal/browser-phone.svg"}
                  className="flex items-center w-[20px]"
                />
                <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                  Desktop and mobile app included!
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center w-full ">
              <div className="w-[90%] bg-slate-800 h-[1px]" />
              <p className="text-sm text-slate-300">It’s free! Create your Redact account now!</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col bg-blue-600 w-[350px] sm:w-[396px] h-[595px] rounded-lg ml-0 lg:ml-20 mt-11">
        <p className="flex font-bold justify-center w-full mt-3 text-lg"> Most popular</p>
        <div className="flex flex-col bg-brand-gray900 w-[342px] sm:w-[388px] h-[545px] rounded-lg -mt-[8px] ml-[4px]">
          <div className="grid grid-cols-2">
            <p className="flex justify-start ml-10 w-full font-bold text-[26px] sm:mt-[34px]">
              Premium
            </p>
            <div
              className={`flex ml-20 h-[25px] w-[80px] rounded-xl bg-blue-600 mt-6 sm:mt-[40px] ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              <p className="flex justify-center items-center w-full text-sm ml-0.5 mt-[13px]">
                Save {personalPricingOptions.premiumYear.seasonalDiscount}
              </p>
            </div>
          </div>
          <ToggleButton
            isTransparent={true}
            ToggleValues={toggleValuePremium}
            DefaultValue={personalPricingOptions.premiumYear.priceVariant}
            OnValueChange={handlePremiumToggleChange}
            buttonColor={"data-[state=on]:text-brand-blue"}
          />
          <div className="ml-10">
            <p
              className={`line-through flex justify-start w-full items-start text-slate-200 text-[14px] ml-0.5 ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              {premiumPrice}
            </p>
            <p
              className={`flex ${isSeasonalDiscountActive ? "-mt-5" : "mt-9"} justify-start w-full items-start text-slate-100 text-[32px]`}
            >
              {premiumDiscountPrice}&nbsp;
              <span className="text-[16px] text-slate-200 mt-5">{premiumPriceDecorator}</span>
            </p>
          </div>
          <div className="flex justify-center w-full">
            <TailwindButton
              buttonBGColor="bg-[#306AFF]"
              buttonHeight="h-[55px] text-xl"
              buttonWidth="w-[315px]"
              buttonBorderColor="border-[#2D5ACC]"
              buttonText="Get Premium"
              buttonURL="/account"
              buttonTextTailwindStyle="font-bold"
            />
          </div>
          <div className="ml-10">
            <p className="flex justify-start font-bold text-[12px] bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text">
              F E A T U R E &nbsp; H I G H L I G H T S
            </p>
            <div className="flex gap-x-2">
              <Image
                alt="checkmark Icon"
                width={0}
                height={0}
                src={"/images/pricing/personal/check.svg"}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Everything in free plan +
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="Posts and likes Icon"
                width={0}
                height={0}
                src={"/images/pricing/personal/post-likes.svg"}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Delete from all supported social services
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="Import Icon"
                width={0}
                height={0}
                src={Import}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Delete unlimited tweets, likes and retweets
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="Calendar Icon"
                width={0}
                height={0}
                src={"/images/pricing/personal/calendar.svg"}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Desktop and mobile app included!
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center w-full ">
            <div className="w-[90%] bg-slate-800 h-[1px]" />
            <p className="text-sm text-slate-300">
              {premiumToggleValue === personalPricingOptions.premiumYear.priceVariant
                ? `Billed at ${isSeasonalDiscountActive ? personalPricingOptions.premiumYear.seasonalDiscountFullPrice : personalPricingOptions.premiumYear.fullPrice} every 12 months`
                : ""}
            </p>
          </div>
        </div>
      </div>

      <div className="flex bg-brand-purple w-[350px] sm:w-[396px] h-[595px] rounded-lg ml-0 lg:ml-20 mt-11">
        <div className="flex flex-col bg-brand-gray900 w-[342px] sm:w-[388px] h-[587px] rounded-lg mt-[4px] ml-[4px]">
          <div className="grid grid-cols-2 mt-0 sm:mt-11">
            <p className="flex justify-start ml-10 w-full font-bold text-[26px] mt-[34px]">
              Ultimate
            </p>
            <div
              className={`flex ml-20 h-[25px] w-[80px] rounded-xl bg-brand-purple mt-[40px] ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              <p className="flex justify-center items-center w-full text-sm ml-0.5 mt-[13px]">
                Save {personalPricingOptions.ultimateYear.seasonalDiscount}
              </p>
            </div>
          </div>
          <ToggleButton
            isTransparent={true}
            ToggleValues={toggleValueUltimate}
            DefaultValue={personalPricingOptions.ultimateYear.priceVariant}
            OnValueChange={handleUltimateToggleChange}
            buttonColor={"data-[state=on]:text-brand-purple"}
          />
          <div className="ml-10">
            <p
              className={`line-through flex justify-start w-full items-start text-slate-200 text-[14px] ml-0.5 ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              {ultimatePrice}
            </p>
            <p
              className={`flex ${isSeasonalDiscountActive ? "-mt-5" : "mt-9"}  justify-start w-full items-start text-slate-100 text-[32px]`}
            >
              {ultimateDiscountPrice}{" "}
              <span className="text-[16px] text-slate-200 mt-5">
                &nbsp; {ultimatePriceDecorator}{" "}
              </span>
            </p>
          </div>
          <div className="flex justify-center w-full">
            <TailwindButton
              buttonBGColor="bg-[#7551CB]"
              buttonHeight="h-[55px] text-xl"
              buttonWidth="w-[315px]"
              buttonBorderColor="border-[#422686]"
              buttonText="Get Ultimate"
              buttonURL="/account"
              buttonTextTailwindStyle="font-bold"
            />
          </div>
          <div className="ml-10">
            <p className="flex justify-start font-bold text-[12px] bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text">
              F E A T U R E &nbsp; H I G H L I G H T S
            </p>
            <div className="flex gap-x-2">
              <Image
                alt="checkmark Icon"
                width={0}
                height={0}
                src={"/images/pricing/personal/check.svg"}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Everything in premium plan +
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="Briefcase Icon"
                width={0}
                height={0}
                src={Briefcase}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Delete from all work & productivity services
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="Zip Icon"
                width={0}
                height={0}
                src={Zip}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Mod tools for discord and reddit
              </p>
            </div>
            <div className="flex gap-x-2 -mt-2">
              <Image
                alt="User and security Icon"
                width={0}
                height={0}
                src={UserSecurity}
                className="flex items-center w-[20px]"
              />
              <p className="flex justify-start w-full items-start text-slate-200 text-[14px]">
                Desktop and mobile app included!
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center w-full ">
            <div className="w-[90%] bg-slate-800 h-[1px]" />
            <p className="text-sm text-slate-300">
              {ultimateToggleValue === personalPricingOptions.ultimateYear.priceVariant
                ? `Billed at ${isSeasonalDiscountActive ? personalPricingOptions.ultimateYear.seasonalDiscountFullPrice : personalPricingOptions.ultimateYear.fullPrice} every 12 months`
                : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceCards;
